module.exports = __webpack_public_path__ + "img/axle_conf_14.61de0fc3.jpg";